import React from 'react'
import GeoProvider from '../../../components/GeoProvider'
import Subscription from './index'
const Subscriptions = () => {
  return (
    <GeoProvider showAddsubscribePop={false}>
      <Subscription></Subscription>
    </GeoProvider>
  )
}
export default Subscriptions